module.exports = __webpack_public_path__ + "img/mobile-menu.8bdeddce.svg";